import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";

const ConfirmPassword = () => {
  const { apiURL } = useContext(ConfigContext);
  const { employee_id } = useParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [SuccessMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    setErrorMessage("");
  }, [confirmPassword, password]);

  const togglePassword = () => {
    setShowPassword((prevState) => !prevState);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
  };

  const validatePassword = (password) => {
    const regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%?&])[A-Za-z\d@$!%?&]{8,}$/;
    return regex.test(password);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match.");
      return;
    }

    if (!validatePassword(password)) {
      setErrorMessage("Password must be at least 8 characters long and include uppercase, lowercase, number, and special character.");
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.post(`${apiURL}User/ConfirmPassword?employee_id=${employee_id}&login_password=${password}`);
      const data = response.data;

      if (data.success === true) {
        setPassword("");
        setConfirmPassword("");
        setSuccessMessage(data.message);
        setTimeout(() => {
          navigate(`/`);
        }, 2000);
      } else {
        setErrorMessage("Something went wrong. Please try again later.");
      }
    } catch (error) {
      console.log("error", error);
      setErrorMessage("Something went wrong. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="auth-page-wrapper pt-5 ">
        <div className="auth-one-bg-position auth-one-bg" id="auth-particles">
          <div className="bg-overlay "></div>
          <div className="shape">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 1440 120"
            >
              <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
            </svg>
          </div>
        </div>
      </div>
      <div className="auth-page-content">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center mt-sm-5 mb-4 text-white">
                <p className="mt-3 fs-15 fw-bolder"></p>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6 col-xl-5">
              <div className="card mt-4">
                <div className="card-body p-4">
                  <div className="text-center mt-2">
                    <div className="text-muted text-center mb-4 mx-lg-3">
                      {SuccessMessage ? (<p className="alert alert-success">{SuccessMessage}</p>) : <h4>Create new password</h4>}
                      <p className="text-muted">
                        Your new password must be different from previously used passwords.
                      </p>
                    </div>
                  </div>
                  <div className="p-2 mt-4">
                    <form onSubmit={handleSubmit}>
                      <div className="mb-3">
                        <label className="form-label" htmlFor="password-input">
                          Password
                        </label>
                        <div className="position-relative auth-pass-inputgroup mb-3">
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control pe-5 password-input"
                            placeholder="Enter password"
                            id="password-input"
                            value={password}
                            onChange={handlePasswordChange}
                            autoComplete="off"
                          />
                          <button
                            className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon"
                            type="button"
                            id="password-addon"
                            onClick={togglePassword}
                          >
                            <i className={showPassword ? "las la-eye align-middle" : "las la-eye-slash align-middle"}></i>
                          </button>
                        </div>
                        {errorMessage && (
                          <p className="alert alert-danger">{errorMessage}</p>
                        )}
                      </div>
                      <div className="mb-3">
                        <label className="form-label" htmlFor="confirm-password-input">
                          Confirm Password
                        </label>
                        <div className="position-relative auth-pass-inputgroup mb-3">
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control pe-5 password-input"
                            placeholder="Enter confirm password"
                            id="confirm-password-input"
                            value={confirmPassword}
                            onChange={handleConfirmPasswordChange}
                            autoComplete="off"
                          />
                          <button
                            className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon"
                            type="button"
                            id="password-addon"
                            onClick={togglePassword}
                          >
                            <i className={showPassword ? "las la-eye align-middle" : "las la-eye-slash align-middle"}></i>
                          </button>
                        </div>
                      </div>
                      <div className="mt-4">
                        <button className="btn btn-secondary w-100" type="submit" disabled={!confirmPassword || !password || isLoading}>
                          {isLoading ? "Please Wait..." : "Confirm"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-4 text-center">
            <p class="mb-0">Wait, I remember my password... <NavLink to={'/'} class="fw-semibold text-primary text-decoration-underline"> Click here </NavLink> </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(ConfirmPassword);
